/**
 * Get table headers for viewer or admin.
 *
 * @returns array of table headers.
 */
export const getFpHeaders = (): string[] => [
  'Period',
  'Commitment',
  null,
  'Contribution received %',
  'Contribution received $',
  'Portfolio gain / (loss)',
  'Total loss from operations',
  'NAV & distribution',
  null,
  'NAV',
  'LP distribution',
  'Carry distribution',
  'Total distribution',
  null,
  ' Net gain / (loss)',
  'TVPI',
  'DPI',
  'RVPI',
  'Net IRR',
  null,
  'Portfolio MOIC',
  'Portfolio IRR',
  null,
  'Total expenses',
  'Management fees',
  'Aggregated organizational expenses',
  'Other OpEx',
  null,
  'Total carried interest',
  'Realized carried interest',
  'Unrealized carried interest',
  'Net gain / (loss) after carry',
  'TVPI (after carry)',
  'DPI (after carry)',
  'RVPI (after carry)',
  'Net IRR (after carry)',
  null,
  'Comment',
  'Prediction',
];

export const getFpHeadersForLogic = (): string[] => [
  'Period',
  'Commitment',
  'empty',
  'Contribution received %',
  'Contribution received $',
  'Portfolio gain / (loss)',
  'Total loss from operations',
  'NAV & distribution',
  'empty(1)',
  'NAV',
  'LP distribution',
  'Carry distribution',
  'Total distribution',
  'empty(0)',
  ' Net gain / (loss)',
  'TVPI',
  'DPI',
  'RVPI',
  'Net IRR',
  'empty(2)',
  'Portfolio MOIC',
  'Portfolio IRR',
  'empty(3)',
  'Total expenses',
  'Management fees',
  'Aggregated organizational expenses',
  'Other OpEx',
  'empty(4)',
  'Total carried interest',
  'Realized carried interest',
  'Unrealized carried interest',
  'Net gain / (loss) after carry',
  'TVPI (after carry)',
  'DPI (after carry)',
  'RVPI (after carry)',
  'Net IRR (after carry)',
  'empty(5)',
  'Comment',
  'Prediction',
];
